import React, { Component } from 'react';
import { Tabs, Tab, Grid, Cell, Card, CardTitle, CardText, CardActions, Button, CardMenu, IconButton } from 'react-mdl';
import { Link } from 'react-router-dom';

export default class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }

  toggleCategories() {

    if(this.state.activeTab === 0){
      return(
        <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/react-logo.png) center / cover'}} >nicolsco-weather-app</CardTitle>
            <CardText>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
            </CardText>
            <CardActions border>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Stackblitz</a>
              <a href="https://nicolsco-weather-app.stackblitz.io" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Live Demo</a>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          <p />

          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/react-logo.png) center / cover'}} >nicolsco-api</CardTitle>
            <CardText>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
            </CardText>
            <CardActions border>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Stackblitz</a>
              <a href="https://nco-api.stackblitz.io" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Live Demo</a>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          <p />

          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/react-logo.png) center / cover'}} >nicolsco-maps</CardTitle>
            <CardText>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
            </CardText>
            <CardActions border>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Stackblitz</a>
              <a href="https://nco-maps.stackblitz.io" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Live Demo</a>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
        </div>
      )
    } else if(this.state.activeTab === 1) {
      return (
        <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/angular-logo.png) center / cover'}} >nicolsco-piza</CardTitle>
            <CardText>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
            </CardText>
            <CardActions border>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Stackblitz</a>
              <a href="https://piza.stackblitz.io" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Live Demo</a>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          <p />

          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/angular-logo.png) center / cover'}} >nicolsco-startup</CardTitle>
            <CardText>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
            </CardText>
            <CardActions border>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Stackblitz</a>
              <a href="https://startup.stackblitz.io" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Live Demo</a>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          <p />

          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/angular-logo.png) center / cover'}} >nicolsco-ionic-app</CardTitle>
            <CardText>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
            </CardText>
            <CardActions border>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Stackblitz</a>
              <a href="https://nco-ionic-app.stackblitz.io" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Live Demo</a>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          <p />

          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/angular-logo.png) center / cover'}} >nicolsco-angular-app</CardTitle>
            <CardText>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
            </CardText>
            <CardActions border>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Stackblitz</a>
              <a href="https://nco-angular-app.stackblitz.io" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Live Demo</a>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
        </div>
      )
    } else if(this.state.activeTab === 2) {
      return (
        <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/vue-logo.png) center / cover'}} >nicolsco-vue-app</CardTitle>
            <CardText>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
            </CardText>
            <CardActions border>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Stackblitz</a>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Live Demo</a>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
        </div>
      )
    } else if(this.state.activeTab === 3) {
      return (
        <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/mongo-logo.png) center / cover'}} >nicolsco-mongodb-app</CardTitle>
            <CardText>
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
            </CardText>
            <CardActions border>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Stackblitz</a>
              <a href="https://stackblitz.com/@nkhrulev" target='_blank' className='mdl-button mdl-js-button mdl-button--colored'>Live Demo</a>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
        </div>
      )
    }

  }

  render() {
    return(
      <div>
        <br /><br />
        <Tabs activeTab={this.state.activeTab} onChange={(tabId) => this.setState({ activeTab: tabId })} ripple>
          <Tab>React</Tab>
          <Tab>Angular</Tab>
          <Tab>VueJS</Tab>
          <Tab>MongoDB</Tab>
        </Tabs>

        <Grid>
          <Cell col={12}>
            <div className="content">{this.toggleCategories()}</div>
          </Cell>
        </Grid>

      </div>
    )
  }
}